import type { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import type { User } from '../../../types/user';
import { Tooltip } from '../Tooltip';

export interface UserFullnameProps {
    firstName: User['firstName'];
    lastName: User['lastName'];
    isDeleted: boolean;
    dataTestid?: string;
    htmlAttributes?: HTMLAttributes<HTMLSpanElement>;
}

export const UserFullname = ({ firstName, lastName, isDeleted, dataTestid, htmlAttributes }: UserFullnameProps) => {
    const { t } = useTranslation();

    if (isDeleted) {
        return (
            <Tooltip
                content={t('Deleted user')}
                dataTestid='user-fullname-tooltip'
            >
                <span
                    className='whitespace-nowrap text-gray-500'
                    data-testid={dataTestid}
                    data-component-name='UserFullname'
                    {...htmlAttributes}
                >
                    {firstName} {lastName}
                </span>
            </Tooltip>
        );
    }
    return (
        <span
            data-component-name='UserFullname'
            data-testid={dataTestid}
            {...htmlAttributes}
        >
            {firstName || ''} {lastName || ''}
        </span>
    );
};
